module.exports = __webpack_public_path__ + "img/外伶仃岛.540ecb76.jpg";